"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_PAYMENT_TYPE_DATA = void 0;
exports.DEFAULT_PAYMENT_TYPE_DATA = {
    amount: 0,
    salesCount: 0,
    refundsCount: 0,
    refundAmount: 0,
    totalCounted: 0,
    variance: 0,
    roundingAmount: 0,
    recordedAmount: 0,
    movedMoney: 0,
    moneyIn: 0,
    moneyOut: 0,
};
//# sourceMappingURL=shifts.js.map